import React from 'react';
import PropTypes from 'prop-types';
import { Typography, MenuItem, Menu } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import { logOut } from 'split-auth/build/redux/auth/authData/actions';

import Separator from '../../../Separator';
import Image from '../../../Image';
import ActionButton from '../../../ActionButton';
import { routes } from '../../../../pages';

import './_accountBadge.scss';

const AccountBadge = ({ anchorEl, closeMenu }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { data = {} } = useSelector(s => s.account);

  const {
    first_name = '',
    last_name = '',
    email = '',
    avatar_url
  } = data;

  const logout = () => {
    closeMenu();
    dispatch(logOut());
    Cookies.remove('bsn_tkn');
    Cookies.remove('ai_chat_token');
    Cookies.remove('ai_chat_token_expires_at');
    history.push(routes.login.business.link());
  };

  return (
    <Menu
      id="account"
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={closeMenu}
      className="account-menu"
    >
      <div className="account-data-container">
        <Image className="avatar" image_url={avatar_url} alt="avatar" />
        <div className="account-data">
          <Typography className="role">admin</Typography>
          <Typography className="bold">{first_name} {last_name}</Typography>
          <Typography className="email">{email}</Typography>
          <ActionButton variant="text" className="edit" to={routes.account.root.path} title="Edit profile" />
        </div>
      </div>
      <Separator />
      <MenuItem className="logout" onClick={logout}>Sign out</MenuItem>
    </Menu>
  );
};

AccountBadge.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  anchorEl: PropTypes.any
};

export default AccountBadge;